var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"timeslice",staticClass:"timeslice",class:{'is-timeslice-loading': _vm.isLoading}},[(_vm.isLoading)?_c('time-slice-loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }